import React from "react";
import {FaFileSignature} from "react-icons/fa";
import ContentPage from "../../components/ContentPage";

const Terms = () => (
	<ContentPage
		icon={<FaFileSignature/>}
		eyebrow="THE RULES OF THE PACK"
		title="Terms of Service"
		summary="These terms set out the agreement between you and Barkr when you access or use the app."
		updated="Effective 10 June 2023">
		<h2>1. Acceptance of terms</h2>
		<p>
			By accessing or using Barkr, you agree to these Terms. If you do not agree, you may not use
			the app.
		</p>

		<h2>2. Using Barkr</h2>
		<p>
			Barkr is provided for personal, non-commercial use. You are responsible for complying with
			applicable laws, keeping your account information accurate, and protecting access to your
			account.
		</p>

		<h2>3. User content</h2>
		<p>
			You may submit photos, text, messages, and other content. You retain ownership of your
			content, while granting Barkr a non-exclusive, worldwide, royalty-free license to host,
			process, reproduce, and display it as needed to operate and promote the service.
		</p>

		<h2>4. Intellectual property</h2>
		<p>
			Barkr’s design, software, features, branding, and original content are protected by
			intellectual-property laws. You may not copy, modify, distribute, or create derivative works
			without written permission.
		</p>

		<h2>5. Prohibited conduct</h2>
		<p>When using Barkr, you agree not to:</p>
		<ul>
			<li>Violate applicable laws or regulations.</li>
			<li>Impersonate another person or misrepresent your identity.</li>
			<li>Engage in fraudulent, abusive, threatening, or deceptive activity.</li>
			<li>Interfere with the app, its servers, security, or other members’ use.</li>
			<li>Collect information from other members without authorization.</li>
			<li>Use Barkr for illegal or unauthorized purposes.</li>
		</ul>

		<h2>6. Safety and member interactions</h2>
		<p>
			You are responsible for your interactions with other members, including deciding when and
			where to meet. Use reasonable care, meet in suitable public places, and follow local rules
			relating to dogs and public spaces.
		</p>

		<h2>7. Indemnification</h2>
		<p>
			To the extent permitted by law, you agree to indemnify Barkr and its affiliates, directors,
			officers, employees, and agents against claims or expenses arising from your use of Barkr,
			your content, or your violation of these Terms.
		</p>

		<h2>8. Limitation of liability</h2>
		<p>
			To the maximum extent permitted by applicable law, Barkr is not liable for indirect,
			incidental, consequential, special, or punitive damages arising from your use of the app.
		</p>

		<h2>9. Governing law</h2>
		<p>
			These Terms are governed by the laws of Bulgaria. Legal proceedings relating to these Terms
			will be brought in the competent courts of Bulgaria, subject to mandatory consumer rights.
		</p>

		<h2>10. Changes to these terms</h2>
		<p>
			We may update these Terms. If a revision is material, we will provide notice through Barkr or
			another appropriate channel. Continued use after the effective date constitutes acceptance.
		</p>

		<h2>11. Contact us</h2>
		<p>
			Questions about these Terms can be sent to{" "}
			<a href="mailto:support@barkr.app">support@barkr.app</a>.
		</p>

		<div className="content-page__notice">
			By using Barkr, you acknowledge that you have read, understood, and agreed to these Terms.
		</div>
	</ContentPage>
);

export default Terms;
